import React from "react";

import StoryCard5 from "../../molecules/story-card5";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Carousel from "../../atoms/carousel";
import Separator from "../../atoms/separator";
import { filterStory } from "../../helper/api";

import "./three-card-slider.m.css";

const ThreeCardSlider = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const allStories = filterStory(collection);

  if (!allStories.length) {
    return null;
  }

  const stories = allStories.splice(0, 7);
  const totalItemsLength =
    typeof window !== "undefined" && window.innerWidth <= 768 ? stories.length : stories.length - 2;
  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <Carousel totalItems={totalItemsLength} showBullets showArrows slidesToShow={3}>
            {stories.map((item, index) => (
              <div styleName="story-container" key={index}>
                <StoryCard5 story={item} />
              </div>
            ))}
          </Carousel>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default ThreeCardSlider;
